import { defineMessages } from 'react-intl';

export default defineMessages({
  showMore: {
    id: 'view.filesPage.searchResult.showMore',
    defaultMessage: '+ show more ({value})',
  },
});
